import React, { useState, useEffect } from 'react';
import { Col, Row, Form, Input, Button, DatePicker, Select, Card } from 'antd';
import { SearchOutlined, ReloadOutlined } from '@ant-design/icons';
import moment from 'moment';

const { RangePicker } = DatePicker;

const AssetTrackingForm = ({ filters, onFilterChange, onRefresh, consortiumOptions }) => {
	const [form] = Form.useForm();
	const [isResetHovered, setIsResetHovered] = useState(false);
	const [isRefreshHovered, setIsRefreshHovered] = useState(false);
  
	// Sync form with external filters
	useEffect(() => {
		form.setFieldsValue({
			...filters,
			dateRange:
				filters.fromDate && filters.toDate
				? [moment(filters.fromDate, 'YYYYMMDD'), moment(filters.toDate, 'YYYYMMDD')]
				: null,
		});
	}, [filters, form]);


	const handleFormChange = (changedValues, allValues) => {
		if (changedValues.dateRange) {
			const [fromDate, toDate] = changedValues.dateRange || [null, null];
			onFilterChange({
				...allValues,
				fromDate: fromDate ? fromDate.format('YYYYMMDD') : '',
				toDate: toDate ? toDate.format('YYYYMMDD') : '',
				dateRange: undefined, // Remove from final filters
			});
		} else {
			onFilterChange(allValues);
		}
	};


	const handleReset = () => {
		form.resetFields();
		const defaultConsortium = 102; // Greece Pilot
		onFilterChange({
			consortiumId: defaultConsortium,
			gtin: '',
			producerGLN: '',
			lotNumber: '',
			fromDate: '',
			toDate: '',
		});
	};


	const handleSearch = () => {
		onRefresh();
	};


	return (
		<Card
			title='Asset Search Filters'
			style={{ marginBottom: 24 }}
			extra={
				<Button
					icon={<ReloadOutlined />}
					onClick={onRefresh}
					style={{
						color: '#00000080',
						borderColor: '#d9d9d9',
						...(isRefreshHovered && {
						color: '#ADD6AD',
						borderColor: '#ADD6AD',
						backgroundColor: '#fff',
						}),
					}}
					onMouseEnter={() => setIsRefreshHovered(true)}
					onMouseLeave={() => setIsRefreshHovered(false)}
				>
					Refresh
				</Button>
			}
		>
			<Form form={form} layout='vertical' onValuesChange={handleFormChange} initialValues={filters}>
				<Row gutter={[16, 16]}>
					<Col xs={24} sm={12} md={8}>
						<Form.Item label='Consortium' name='consortiumId'>
							<Select placeholder='Select Consortium' options={consortiumOptions} />
						</Form.Item>
					</Col>
					<Col xs={24} sm={12} md={8}>
						<Form.Item label='GTIN' name='gtin'>
							<Input placeholder='Enter GTIN' />
						</Form.Item>
					</Col>
					<Col xs={24} sm={12} md={8}>
						<Form.Item label='Lot Number' name='lotNumber'>
							<Input placeholder='Enter Lot Number' />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={[16, 16]}>
					<Col xs={24} md={12} lg={8}>
						<Form.Item label='Producer GLN' name='producerGLN'>
							<Input placeholder='Enter GLN' />
						</Form.Item>
					</Col>
					<Col xs={24} md={12} lg={16}>
						<Form.Item label='Production Date Range' name='dateRange'>
							<RangePicker style={{ width: '100%' }} format='YYYY-MM-DD' />
						</Form.Item>
					</Col>
				</Row>
				<Row>
					<Col span={24} style={{ textAlign: 'right' }}>
						<Button
							type='primary'
							icon={<SearchOutlined />}
							onClick={handleSearch}
							style={{ marginRight: 8, color: '#000000', backgroundColor: '#ADD6AD', borderColor: '#ADD6AD' }}
						>
							Search
						</Button>
						<Button
							onClick={handleReset}
							style={{
								color: '#00000080',
								borderColor: '#d9d9d9',
								...(isResetHovered && {
								color: '#ADD6AD',
								borderColor: '#ADD6AD',
								backgroundColor: '#fff',
								}),
							}}
							onMouseEnter={() => setIsResetHovered(true)}
							onMouseLeave={() => setIsResetHovered(false)}
						>
							Reset
						</Button>
					</Col>
				</Row>
			</Form>
		</Card>
	);
};

export default AssetTrackingForm;
